/**  Shows a dismissable cookie banner */
class CookieBannerComponent {
    private readonly cookieName = "cookie-banner-dismissed";
    // Any domains ending with these values will treated as wildcard domains, so 
    // the cookie will apply across any subdomains also.
    private readonly wildcardDomains = ["parliament.uk"];

    /**  Initialises the cookie banner component */
    init() {
        if (!this.isCookieBannerDismissed()) {
            var bannerElement = $("#cookie-banner");
            bannerElement.removeAttr("hidden");

            bannerElement.find(".dismiss-button").on("click", (event: JQuery.TriggeredEvent) => {
                bannerElement.hide();
                this.setCookieBannerDismissed();
                event.preventDefault();
            });
        }
    }

    private isCookieBannerDismissed() {
        var name = this.cookieName + "=";
        var setting;

        // Read it from the cookie and set value is "true"
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                setting = c.substring(name.length, c.length);
            }
        }

        return setting === "true";
    }

    private setCookieBannerDismissed() {
        var date = new Date();

        // Pop in a cookie. Set to expire in 1 year
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        var cookie = this.cookieName + "=true;" + expires

        // If domain is in the wildcard list, then set the domain
        this.wildcardDomains.forEach(function (domain) {
            var domain = domain.toLowerCase()
            var isWildcardDomain = window.location.hostname.toLowerCase().indexOf(domain) > -1;
            if (isWildcardDomain) {
                // Period (.) in front of domain indicates will work across subdomains
                cookie += ";domain=." + domain;
            }
        });

        cookie += ";path=/";

        document.cookie = cookie;
    }
}

$(function () {
    let cookieBanner = new CookieBannerComponent();
    cookieBanner.init();
});